import { create } from 'apisauce';

// Notes: invoiceId is not the id of invoice, it is currently invoice token id
const getPaymentAuthToken = async (invoiceId, payload) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/fullsteam/payments/${invoiceId}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.post('', payload);
  return response;
};

const postInvoicePayment = async ({ invoiceId, body }) => {
  try {
    const api = create({
      baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/fullsteam/invoice-payment/${invoiceId}`,
      headers: {
        'content-type': 'application/json',
        'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      },
    });

    const response = await api.post('', { ...body });
    return response;
  } catch(e) {
    return null;
  }
};

const getInvoiceDetail = async ({ invoiceId }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/fullsteam/invoice/${invoiceId}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.get('', {});
  return response;
};

const getRefundDetail = async ({ invoiceId, paymentId }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/fullsteam/invoice-payment-info/${invoiceId}/${paymentId}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.get('', {});
  return response;
};

const postRefundPayment = async ({ invoiceId, paymentId, body }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/fullsteam/invoice-refund/${invoiceId}/${paymentId}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.post('', { ...body });
  return response;
};

export { getPaymentAuthToken, getInvoiceDetail, postInvoicePayment, getRefundDetail, postRefundPayment };
